<template>
  <div class="enterprise-apply-container">
    <div class="apply-content">
      <h2 class="form-title">企业入驻申请</h2>
      <el-form :model="form" :rules="rules" ref="applyForm" label-width="140px" class="apply-form">

        <!-- 企业基本信息 -->
        <div class="section-title">企业基本信息</div>

        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="form.companyName" placeholder="请输入公司名称（需与营业执照一致）"></el-input>
        </el-form-item>

        <el-form-item label="社会信用代码" prop="creditCode">
          <el-input v-model="form.creditCode" placeholder="请输入统一社会信用代码"></el-input>
        </el-form-item>

        <el-form-item label="经营范围" prop="businessScope">
          <el-input type="textarea" v-model="form.businessScope" placeholder="请输入主要经营范围（选填，简要描述即可）"
            :autosize="{ minRows: 2, maxRows: 6 }">
          </el-input>
        </el-form-item>

        <el-form-item label="营业执照" prop="licenseUrl">
          <el-upload class="license-uploader" :action="uploadConfig.action" :headers="uploadConfig.headers"
            :show-file-list="false" :on-success="(res) => handleUploadSuccess(res, 'licenseUrl')"
            :before-upload="beforeUpload">
            <img v-if="form.licenseUrl" :src="$http.getFullImageUrl(form.licenseUrl)" class="license-img">
            <i v-else class="el-icon-plus uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">请上传清晰的营业执照扫描件或照片</div>
        </el-form-item>

        <!-- 法人信息 -->
        <div class="section-title">法人代表信息</div>

        <el-form-item label="法人姓名" prop="legalPerson">
          <el-input v-model="form.legalPerson" placeholder="请输入法人代表姓名"></el-input>
        </el-form-item>

        <el-form-item label="法人身份证号" prop="legalPersonIdCard">
          <el-input v-model="form.legalPersonIdCard" placeholder="请输入法人身份证号码"></el-input>
        </el-form-item>

        <el-form-item label="身份证正面" prop="idCardFrontUrl">
          <el-upload class="id-card-uploader" :action="uploadConfig.action" :headers="uploadConfig.headers"
            :show-file-list="false" :on-success="(res) => handleUploadSuccess(res, 'idCardFrontUrl')"
            :before-upload="beforeUpload">
            <img v-if="form.idCardFrontUrl" :src="$http.getFullImageUrl(form.idCardFrontUrl)" class="id-card-img">
            <div v-else class="id-card-placeholder">
              <i class="el-icon-plus"></i>
              <span>人像面</span>
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="身份证反面" prop="idCardBackUrl">
          <el-upload class="id-card-uploader" :action="uploadConfig.action" :headers="uploadConfig.headers"
            :show-file-list="false" :on-success="(res) => handleUploadSuccess(res, 'idCardBackUrl')"
            :before-upload="beforeUpload">
            <img v-if="form.idCardBackUrl" :src="$http.getFullImageUrl(form.idCardBackUrl)" class="id-card-img">
            <div v-else class="id-card-placeholder">
              <i class="el-icon-plus"></i>
              <span>国徽面</span>
            </div>
          </el-upload>
        </el-form-item>

        <!-- 联系信息 -->
        <div class="section-title">联系信息</div>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入联系电话（将作为登录账号）"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loading" class="submit-btn"
            size="large">提交申请</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnterpriseApply',
  data() {
    return {
      loading: false,
      form: {
        companyName: '',
        creditCode: '',
        licenseUrl: '',
        legalPerson: '',
        legalPersonIdCard: '',
        idCardFrontUrl: '',
        idCardBackUrl: '',
        phone: ''
      },
      rules: {
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        creditCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          { pattern: /^[0-9A-Z]{18}$/, message: '请输入正确的18位统一社会信用代码', trigger: 'blur' }
        ],
        licenseUrl: [
          { required: true, message: '请上传营业执照', trigger: 'change' }
        ],
        legalPerson: [
          { required: true, message: '请输入法人代表姓名', trigger: 'blur' }
        ],
        legalPersonIdCard: [
          { required: true, message: '请输入法人身份证号', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'blur' }
        ],
        idCardFrontUrl: [
          { required: true, message: '请上传身份证正面', trigger: 'change' }
        ],
        idCardBackUrl: [
          { required: true, message: '请上传身份证反面', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    uploadConfig() {
      return this.$http.getPublicUploadConfig()
    }
  },
  methods: {
    handleUploadSuccess(res, field) {
      if (res.success) {
        this.form[field] = res.data.fileUrl
        this.$message.success('上传成功')
      } else {
        this.$message.error('上传失败: ' + res.message)
      }
    },
    beforeUpload(file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isImg) {
        this.$message.error('图片只能是 JPG/PNG 格式!');
      }
      if (!isLt20M) {
        this.$message.error('上传图片大小不能超过 20MB!');
      }
      return isImg && isLt20M;
    },
    submitForm() {
      this.$refs.applyForm.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            const response = await this.$http.post('/public/enterprise/apply', this.form)
            if (response.success) {
              this.$alert('您的入驻申请已提交成功，请耐心等待管理员审核。审核通过后，您可使用手机号和初始密码123456登录系统。', '提交成功', {
                confirmButtonText: '确定',
                callback: () => {
                  this.$router.push('/')
                }
              })
            }
          } catch (error) {
            const message = error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : error.message
            this.$message.error('提交失败: ' + message)
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.enterprise-apply-container {
  min-height: calc(100vh - 60px);
  background-color: #f5f7fa;
  padding: 40px 20px;
  display: flex;
  justify-content: center;
}

.apply-content {
  width: 100%;
  max-width: 800px;
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.form-title {
  text-align: center;
  color: #303133;
  margin-bottom: 40px;
  font-size: 28px;
  font-weight: 600;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #409eff;
  margin: 30px 0 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #409eff;
}

.apply-form {
  padding-right: 40px;
}

/* 修复上传组件样式 */
.license-uploader ::v-deep .el-upload,
.id-card-uploader ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.license-uploader ::v-deep .el-upload:hover,
.id-card-uploader ::v-deep .el-upload:hover {
  border-color: #409eff;
}

.license-uploader ::v-deep .el-upload {
  width: 260px;
  height: 180px;
}

.id-card-uploader ::v-deep .el-upload {
  width: 260px;
  height: 160px;
}

.uploader-icon {
  font-size: 28px;
  color: #8c939d;
}

.license-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.id-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.id-card-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #8c939d;
}

.id-card-placeholder i {
  font-size: 24px;
  margin-bottom: 8px;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}

.submit-btn {
  width: 200px;
  margin-top: 20px;
}

@media screen and (max-width: 768px) {
  .apply-content {
    padding: 20px;
  }

  .apply-form {
    padding-right: 0;
  }

  .submit-btn {
    width: 100%;
  }
}
</style>
